/* eslint-disable max-len */
import 'react';

const ArrowUpSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "></g>
            <g fill="currentColor" fillRule="nonzero">
                <path d="M3.95147186,7.55147186 C4.36803111,7.13491262 5.01464967,7.08862826 5.48233321,7.41261878 L5.64852814,7.55147186 L12,13.9032 L18.3514719,7.55147186 C18.7680311,7.13491262 19.4146497,7.08862826 19.8823332,7.41261878 L20.0485281,7.55147186 C20.4650874,7.96803111 20.5113717,8.61464967 20.1873812,9.08233321 L20.0485281,9.24852814 L12.8485281,16.4485281 C12.4319689,16.8650874 11.7853503,16.9113717 11.3176668,16.5873812 L11.1514719,16.4485281 L3.95147186,9.24852814 C3.48284271,8.77989899 3.48284271,8.02010101 3.95147186,7.55147186 Z" id="Path-131" transform="translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) "></path>
            </g>
        </g>
    </svg>
);
export default ArrowUpSvg;
